<template>
  <div class="step-wrap">
    <div v-for="(item, i) in stepList" :key="i" class="step-item">
      <div class="icon-box">
        <div :class="['circle-box', activeStep >= i ? 'circle-active' : '']">{{ i + 1 }}</div>
        <div :class="['title', activeStep >= i ? 'title-active' : '']">{{ item.name }}</div>
        <div
          v-show="i !== stepList.length - 1"
          :class="['line', activeStep == i + 1 ? 'line-active' : '']"
        ></div>
      </div>
      <div :class="['tips-box']">
        {{ stepType == 1 ? item.tip1 : item.tip2 }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    stepType: {
      type: String,
      default: () => {
        return '1'
      }
    }
  },
  data() {
    return {
      stepList: [
        {
          name: '步骤一',
          tip1: '根据本任务专用公钥对原始数据进行加密,获取加密结果',
          tip2: '根据本任务专用随机因子生成承诺和证明'
        },
        { name: '步骤二', tip1: '将加密后数据进行上链', tip2: '提交零知识证明中的承诺参与计算' }
      ],
      activeStep: 0
    }
  },
  methods: {
    changeStep(step) {
      this.activeStep = step
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'step-wrap',
  (
    --step-wrap-circle-bg-color: rgba(163, 175, 181, 1),
    --step-wrap-circle-active-bg-color: #6dd4ff,
    --step-wrap-circle-active-border-color: #fff,
    --step-wrap-circle-active-text-color: rgba(109, 212, 255, 1),
    --step-wrap-circle-border-color: rgba(235, 235, 235, 1),
    --step-wrap-tip-text-color: rgba(255, 255, 255, 0.6),
    --step-wrap-tip-text-active-color: rgba(255, 255, 255, 0.9)
  ),
  (
    --step-wrap-circle-bg-color: rgba(163, 175, 181, 1),
    --step-wrap-circle-active-bg-color: #45c2ff,
    --step-wrap-circle-active-border-color: rgba(235, 235, 235, 1),
    --step-wrap-circle-active-text-color: rgba(109, 212, 255, 1),
    --step-wrap-circle-border-color: rgba(235, 235, 235, 1),
    --step-wrap-tip-text-color: rgba(90, 105, 115, 1),
    --step-wrap-tip-text-active-color: rgba(109, 212, 255, 1)
  )
);
.step-wrap {
  @include adaptation(
    (
      --step-wrap-circle-width: 32px,
      --step-wrap-circle-border: 4px,
      --step-wrap-circle-label-font-size: 16px,
      --step-wrap-circle-label-margin-right: 8px,
      --step-wrap-line-border-width: 1px,
      --step-wrap-line-width: 160px,
      --step-wrap-tip-text-size: 12px,
      --step-wrap-tip-text-min-width: 200px
    )
  );
  display: flex;
  .step-item {
    .icon-box {
      display: flex;
      align-items: center;
    }
    .circle-box {
      width: var(--step-wrap-circle-width);
      height: var(--step-wrap-circle-width);
      background: var(--step-wrap-circle-bg-color);
      border-radius: 50%;
      border: var(--step-wrap-circle-border) solid var(--step-wrap-circle-border-color);
      margin-right: var(--step-wrap-circle-label-margin-right);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .circle-active {
      background: var(--step-wrap-circle-active-bg-color);
      border-color: var(--step-wrap-circle-active-border-color);
      color: var(--step-wrap-circle-active-border-color);
    }
    .title {
      font-size: var(--step-wrap-circle-label-font-size);
      color: var(--step-wrap-circle-bg-color);
    }
    .title-active {
      color: var(--step-wrap-circle-active-text-color);
    }
    .line {
      width: var(--step-wrap-line-width);
      border: var(--step-wrap-line-border-width) solid var(--step-wrap-circle-border-color);
      margin: 0 40px;
    }
    .line-active {
      border-color: var(--step-wrap-circle-active-text-color);
    }
    .tips-box {
      width: var(--step-wrap-tip-text-min-width);
      color: var(--step-wrap-tip-text-color);
      font-size: var(--step-wrap-tip-text-size);
      margin-top: var(--step-wrap-tip-text-size);
    }
    .tips-box-active {
      color: var(--step-wrap-tip-text-active-color);
    }
  }
}
</style>
